import BaseComponent from 'foundation/base-component';
import createEvent from '../../../general/js/create-event';
import { onReady } from './loadRecaptcha';

export const EVENT_AFTER_SUBMIT = 'recaptcha:afterSubmit';
export const EVENT_ON_ERROR = 'recaptcha:onError';

export default class RecaptchaComponent extends BaseComponent {
    constructor(...args) {
        super(...args);
        this.captchaId = null;

        this.containerElement = this.refs.container;
        this.inputElement = this.refs.input;

        this.sitekey = this.getAttribute(this.element, 'sitekey');

        this.onAfterSubmit = this.onAfterSubmit.bind(this);
        this.onError = this.onError.bind(this);
        this.init = this.init.bind(this);
        this.successCallback = this.successCallback.bind(this);
        this.expiredCallback = this.expiredCallback.bind(this);

        onReady(this.init);
    }

    static getRequiredRefs() {
        return ['container', 'input'];
    }

    init(grecaptcha) {
        this.grecaptcha = grecaptcha;

        this.captchaId = grecaptcha.render(this.containerElement, {
            sitekey: this.sitekey,
            callback: this.successCallback,
            'expired-callback': this.expiredCallback
        });

        this.addListener(this.inputElement, EVENT_AFTER_SUBMIT, this.onAfterSubmit);
        this.addListener(this.inputElement, EVENT_ON_ERROR, this.onError);
    }

    successCallback(response) {
        this.inputElement.value = response;
        this.inputElement.dispatchEvent(createEvent('input'));
        this.inputElement.dispatchEvent(createEvent('change'));
    }

    expiredCallback() {
        this.reset();
    }

    onAfterSubmit() {
        this.grecaptcha.reset(this.captchaId);
        this.reset();
    }

    onError() {
        this.grecaptcha.reset(this.captchaId);
        this.reset();
    }

    reset() {
        this.inputElement.value = '';
        this.inputElement.dispatchEvent(createEvent('input'));
        this.inputElement.dispatchEvent(createEvent('change'));
    }
}
